module.exports = __webpack_public_path__ + "static/exterior-1-1baef28aab9dd110c78df80893bdd7cf.jpg";